import { RegisterView as UIRegisterView, useHead } from '@mybonus/ui';

export function RegisterView() {
	useHead({ subtitle: 'Bli medlem idag!' });

	return <UIRegisterView />;
}
